import {Pipe, PipeTransform} from "@angular/core";

@Pipe({
    name: 'decimal',
    standalone: false
})
export class DbDecimalPipe implements PipeTransform {
  transform(num: number) {
    let str = num.toString().split(".");
    str[0] = str[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    return str.join(".").trim().replace(",", ".");
  }
}
